(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.LbacQuizEngine = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  var FORMATS = ["bracelet", "collier", "bague", "pierre", "any"];

  function seedValue() {
    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      return crypto.getRandomValues(new Uint32Array(1))[0];
    }
    return Math.floor(Math.random() * 4294967296);
  }

  function hash(seed, text) {
    var h = (seed ^ 2166136261) >>> 0;
    for (var i = 0; i < text.length; i++) {
      h ^= text.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    h ^= h >>> 13;
    h = Math.imul(h, 1540483477) >>> 0;
    return (h ^ (h >>> 15)) >>> 0;
  }

  function normalize(answers, data) {
    var a = {
      intent: answers.intent,
      format: answers.format,
      color: answers.color || "any",
      sign: answers.sign || "none"
    };
    if (!data.intents[a.intent]) throw new TypeError("invalid_intent");
    if (FORMATS.indexOf(a.format) === -1) throw new TypeError("invalid_format");
    if (a.color !== "any" && !data.colors[a.color]) throw new TypeError("invalid_color");
    if (a.sign !== "none" && !data.signs[a.sign]) throw new TypeError("invalid_sign");
    return a;
  }

  function rank(answers, data, seed) {
    var a = normalize(answers, data);
    var list = [];
    data.stones.forEach(function (stone) {
      var level = Number(stone.intents[a.intent] || 0);
      if (level <= 0) return;
      var destination = stone.collections[a.format];
      if (!destination || !destination.handle) return;
      var colorMatch = a.color !== "any" && stone.colors.indexOf(a.color) !== -1;
      var signMatch = a.sign !== "none" && stone.signs.indexOf(a.sign) !== -1;
      list.push({
        stone: stone,
        destination: destination,
        level: level,
        colorMatch: colorMatch,
        signMatch: signMatch,
        tie: hash(seed >>> 0, stone.id)
      });
    });
    list.sort(function (x, y) {
      return (y.level - x.level) ||
        (Number(y.colorMatch) - Number(x.colorMatch)) ||
        (Number(y.signMatch) - Number(x.signMatch)) ||
        (x.tie - y.tie) ||
        (x.stone.order - y.stone.order);
    });
    return {
      answers: a,
      candidates: list,
      colorUnavailable: a.color !== "any" && !list.some(function (x) { return x.colorMatch; })
    };
  }

  var REASON_TEXTS = {
    intent: "Votre envie : [intent]",
    formatAny: "Vous restez ouvert(e) à tous les formats",
    format: "Format choisi : [format]",
    color: "Elle a la couleur qui vous attire",
    sign: "Elle est traditionnellement associée au signe [sign]"
  };

  function fill(template, key, value) {
    return String(template).split("[" + key + "]").join(value);
  }

  function reasons(item, answers, data, texts) {
    var t = texts || REASON_TEXTS;
    var out = [fill(t.intent, "intent", data.intents[answers.intent].toLowerCase())];
    out.push(answers.format === "any" ? t.formatAny : fill(t.format, "format", data.formats[answers.format].toLowerCase()));
    if (item.colorMatch) out.push(t.color);
    if (item.signMatch) out.push(fill(t.sign, "sign", data.signs[answers.sign]));
    return out;
  }

  function pick(ranked, isAvailable, max) {
    max = max || 3;
    var chosen = [];
    for (var i = 0; i < ranked.candidates.length && chosen.length < max; i++) {
      if (!isAvailable || isAvailable(ranked.candidates[i])) chosen.push(ranked.candidates[i]);
    }
    return chosen;
  }

  return Object.freeze({ FORMATS: FORMATS, seedValue: seedValue, rank: rank, pick: pick, reasons: reasons });
});
